document.addEventListener('DOMContentLoaded', () => {
	// Add change event to category and tag <select> dropdowns
	document.querySelectorAll('#categories, #tags').forEach(select => {
		select.addEventListener('change', (e) => {
			const url = e.target.value;
			const defaultUrl = e.target.dataset.default;
			if (url) {
				window.location.href = url === 'all' ? defaultUrl : url;
			}
			e.preventDefault();
		});
	});

	// Set up table of contents from headings inside the article
	const anchorsContainer = document.querySelector('.blog-anchors');
	const toc = document.getElementById('table-of-contents');
	const article = document.querySelector('.article-content');
	let links = parseInt(anchorsContainer?.dataset.links) || 3;
	let i = 1;

	// Generate anchor links from h1, h2, h3 tags
	if (article && toc) {
		article.querySelectorAll('h1, h2, h3').forEach((heading, index) => {
			i++;
			const cleanText = heading.textContent.replace(/[^a-zA-Z0-9 ]/g, '');
			const anchorId = heading.textContent.toLowerCase().split(' ').join('-') + '-' + index;

			// Add ID and class to the heading
			heading.classList.add('anchor');
			heading.id = anchorId;

			// Create a TOC <li> with a link to the heading
			const li = document.createElement('li');
			li.className = anchorId;
			li.style.display = i <= links ? 'block' : '';
			li.innerHTML = `<a href="#${anchorId}">${cleanText}</a>`;
			toc.appendChild(li);
		});
	}

	// If there are more than the allowed number of links, add "More/Less" toggles
	if (i > links && anchorsContainer) {
		const ul = anchorsContainer.querySelector('ul');
		const more = document.createElement('li');
		more.className = 'anchor-more';
		more.style.display = 'block';
		more.innerHTML = `<a href="#">&plus; More</a>`;
		const less = document.createElement('li');
		less.className = 'anchor-less';
		less.innerHTML = `<a href="#">&minus; Less</a>`;
		less.style.display = 'none';
		ul.append(more, less);

		// Show all links when More is clicked
		more.addEventListener('click', (e) => {
			e.preventDefault();
			more.style.display = 'none';
			ul.classList.add('show-all');
			less.style.display = 'block';
		});

		// Hide extra links when Less is clicked
		less.addEventListener('click', (e) => {
			e.preventDefault();
			less.style.display = 'none';
			ul.classList.remove('show-all');
			more.style.display = 'block';
		});
	}
});